import type { ReactElement } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { Card } from '@/modules/perseo-billing/ui/react/src/components/beta';

import { ModalGiftCardError } from '../../../fallback/billing-giftcard-fallback';

import { GiftCardAuthenticationMessage } from './authentication-message.component';
import { GiftCardView } from './gift-card-view.component';

export const GiftCardSection = (): ReactElement => {
  const isGuest = !!localStorage.getItem('guestSessionData');

  const { giftCardError } = useAppSelector((state) => state.billing);

  return (
    <>
      <Card>
        <div className="co-p-16px lg:co-p-24px co-pt-0px">
          {isGuest ? <GiftCardAuthenticationMessage /> : <GiftCardView />}
        </div>
      </Card>
      {giftCardError && <ModalGiftCardError />}
    </>
  );
};
